const CHECK_INFORMATION =
  'Пожалуйста, проверьте введенные данные. Внести изменения вы сможете в личном кабинете после подключения.';

const ALL_SUBCATEGORIES = 'Все';

export const DETSKIJ_NAME = 'detskij';

export { CHECK_INFORMATION, ALL_SUBCATEGORIES };
